// extracted by mini-css-extract-plugin
export default {"validationErrorContainer":"validation-errors-container__validation-error-container__iQdf0"};